/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import cx from 'classnames';

export const Button = ({
  className, children, disabled, loading, color, ...props
}) => (
  <button
    className={cx('glow pointer o-90', className, { [`bg-${color}`]: color })}
    disabled={disabled || loading}
    {...props}
  >
    {loading
      ? <div className='tc'><img className='w2 h2' src={require('assets/img/loading.gif')} alt='loading' /></div>
      : children}
  </button>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  color: PropTypes.string,
};
